export default __webpack_public_path__ + "static/media/tech-shop.58f28e5e.png";